import { IFieldValidator } from 'src/app/interfaces/field-settings.interface';
import { IFieldValidationParams } from 'src/app/interfaces/zc-validation-result.interface';

type CanBeAppliedFunction = (model: any) => boolean;

export class RequiredFieldValidator implements IFieldValidator {
    private errorMessage = 'Required field';
    private canBeApplied?: CanBeAppliedFunction;

    propertyName: string = null;

    constructor(canBeApplied?: CanBeAppliedFunction) {
        this.canBeApplied = canBeApplied || (() => true);
    }

    validate(params: IFieldValidationParams): string {
        if (!this.canBeApplied(params.currentModelState) || this.isValid(params)) {
            return null;
        }

        return this.errorMessage;
    }

    private isValid(params: IFieldValidationParams): boolean {
        return (
            params.currentModelState[this.propertyName] !== null &&
            params.currentModelState[this.propertyName] !== undefined
        );
    }
}
